export default "__VITE_ASSET__CCmsDGyd__"